export enum SectionGroupType {
  NATIONAL_DETERMINED_SECTION = 'NATIONAL_DETERMINED_SECTION',
}
